import type { ReactNode } from 'react'

export type NavIconName = 'dashboard' | 'pos' | 'customers' | 'products' | 'purchases' | 'warehouse' | 'sales' | 'finance' | 'delivery' | 'advisor' | 'users' | 'messages' | 'settings'

const paths: Record<NavIconName, ReactNode> = {
  dashboard: <><path d="M3 9.5 10 3.5l7 6" /><path d="M5 8v8.5h4V12h2v4.5h4V8" /></>,
  customers: <><circle cx="7.5" cy="7" r="2.8" /><path d="M2.5 16.5a5 5 0 0 1 10 0" /><circle cx="14" cy="7.8" r="2.2" /><path d="M13.5 12.2a4.2 4.2 0 0 1 4 4.3" /></>,
  products: <><path d="m10 2.5 7 3.5v8l-7 3.5L3 14V6z" /><path d="m3 6 7 3.5L17 6M10 9.5v8" /></>,
  pos: <><path d="M2.5 3h2l2 9.5h9l1.8-6.5H5.4" /><circle cx="8" cy="16.5" r="1.2" /><circle cx="14.5" cy="16.5" r="1.2" /></>,
  purchases: <><rect x="4" y="3.5" width="12" height="14" rx="1.5" /><path d="M7.5 2.5h5v2.5h-5zM7 9h6M7 12h6M7 15h3" /></>,
  warehouse: <><path d="M2.5 7.5 10 3l7.5 4.5V17h-15z" /><path d="M6 17v-6h8v6M6 13.5h8" /></>,
  sales: <><path d="M5 2.5h10v15l-2-1.3-1.5 1.3-1.5-1.3-1.5 1.3L7 16.2l-2 1.3z" /><path d="M7.5 6.5h5M7.5 9.5h5M7.5 12.5h3" /></>,
  finance: <><path d="M2.5 7.5 10 3l7.5 4.5M4 7.5v7M8 7.5v7M12 7.5v7M16 7.5v7M2.5 17h15" /></>,
  delivery: <><path d="M2.5 5h9v8h-9zM11.5 8h3l2.5 3v2h-5.5" /><circle cx="5.5" cy="14.5" r="1.6" /><circle cx="14" cy="14.5" r="1.6" /></>,
  advisor: <><path d="M3 16l4.5-5 3 3L17 6.5" /><path d="M13 6.5h4v4" /></>,
  settings: <><circle cx="10" cy="10" r="2.6" /><path d="M10 2.5v2M10 15.5v2M2.5 10h2M15.5 10h2M4.7 4.7l1.4 1.4M13.9 13.9l1.4 1.4M4.7 15.3l1.4-1.4M13.9 6.1l1.4-1.4" /></>,
  messages: <><path d="M3 4.5h14v9.5H9l-4 3v-3H3z" /><path d="M6.5 8h7M6.5 11h4.5" /></>,
  users: <><circle cx="8" cy="7" r="3" /><path d="M2.5 17a5.5 5.5 0 0 1 9-4.2" /><circle cx="15" cy="14.5" r="1.8" /><path d="M15 11v1.2M15 16.8V18M12.5 14.5h-1.2M18.7 14.5h-1.2" /></>,
}

/** The main menu's icons: 20×20, stroked in the link's colour. */
export function NavIcon({ name }: { name: NavIconName }) {
  return (
    <svg viewBox="0 0 20 20" className="h-5 w-5 shrink-0" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  )
}
